// Core packages
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// Third party packages
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfigService } from 'src/app/shared/services/config.service';
var ViewStructureDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ViewStructureDialogComponent(dialogRef, data, configService, translateService, authService, activatedRoute, settingsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.translateService = translateService;
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.send'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paper-plane',
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
        this.formIsLoading = false;
        this.mappingIndex = [];
        this.formActiveSubitemId = "";
        this.formActiveSection = "";
        this.sectionPlant = false;
        this.condoStructureTemplateId = "";
        this.condoStructureTemplate = [];
    }
    /**
     * Init component
     *
     */
    ViewStructureDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dialog = document.getElementsByClassName("mat-dialog-content")[0];
        if (this.data && this.data.propertyData) {
            this.property = this.data.propertyData;
        }
        if (this.property) {
            this.subscriptions.push(this.settingsService.getStructure().subscribe(function (res) {
                if (res.status) {
                    if (res.condoStructureTemplate &&
                        Array.isArray(res.condoStructureTemplate) &&
                        res.condoStructureTemplate.length > 0 &&
                        res.condoStructureTemplate[0].area &&
                        Array.isArray(res.condoStructureTemplate[0].area)) {
                        _this.condoStructureTemplateId = res.condoStructureTemplate[0]._id;
                        _this.condoStructureTemplate = res.condoStructureTemplate[0].area;
                        _this.mappingIndex = _this.condoStructureTemplate;
                        _this.mappingIndex = _this.translateKeys2(["placeholder", "label"], _this.mappingIndex);
                        _this.checkPropertyType();
                        console.log("this.mappingIndex", _this.mappingIndex);
                    }
                }
            }));
        }
        if (this.data && this.data.condoStructure) {
            this.condoStructure = this.data.condoStructure;
        }
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get logged user's role data
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        if (!this.currentRole.propertiesPermission) {
            this.currentRole.propertiesPermission = {
                amiantoDoc: false,
                amminImmobile: false,
                antincendio: false,
                ascensoriEMontauto: false,
                contratti: false,
                edile: false,
                expiresUnlimited: false,
                gestionaleAmministrativo: false,
                impiantoElettrico: false,
                impiantiElettronici: false,
                impiantiRicreativiSportivi: false,
                impiantiSpeciali: false,
                lineaVita: false,
                mappatura: false,
                riscaldamentoCondizionamento: false,
                trattamentoAcqua: false,
                unitaImmobiliari: false,
                unlimited: false,
                gestionaleContabile: false,
                urbanisticaEdEdilizia: false,
                catasto: false,
                preventivi: false,
            };
        }
        // Stop loading dialog
        setTimeout(function () {
            _this.dialogIsLoading = false;
        }, 1000);
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle after view init cycle hook
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.ngAfterViewInit = function () {
        // Leave this code under ngAfterViewInit to prevent expressionChangedAfterChecked error
    };
    /**
     * Handle property type check
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.checkPropertyType = function () {
        // Check property type: Condo or BSC
        if (this.property.type === "bsc") {
            var strutture = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.strutture";
            });
            if (strutture
                && strutture.content
                && Array.isArray(strutture.content)) {
                var index = strutture.content.findIndex(function (item) {
                    return item.key === "condominiBsc";
                });
                strutture.content[index].hidden = false;
                index = strutture.content.findIndex(function (item) {
                    return item.key === "fabbricatoAbitativo";
                });
                strutture.content[index].hidden = true;
                index = strutture.content.findIndex(function (item) {
                    return item.key === "struttureFabbindip";
                });
                strutture.content[index].hidden = false;
            }
            var trattamentoAcqua = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.trattamentoAcqua";
            });
            if (trattamentoAcqua
                && trattamentoAcqua.content
                && Array.isArray(trattamentoAcqua.content)) {
                var index = trattamentoAcqua.content.findIndex(function (item) {
                    return item.key === "sottostazioneAltroCondBsc";
                });
                trattamentoAcqua.content[index].hidden = true;
            }
            var riscaldamentoCondizionamento = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.riscaldamentoCondizionamento";
            });
            if (riscaldamentoCondizionamento
                && riscaldamentoCondizionamento.content
                && Array.isArray(riscaldamentoCondizionamento.content)) {
                // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                //   return item.key === "sottostazioniCt"
                // });
                // riscaldamentoCondizionamento.content[index].hidden = true;
                // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                //   return item.key === "centraleRicervimento"
                // });
                // riscaldamentoCondizionamento.content[index].hidden = true;
                var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                    return item.key === "cannaCollettiva";
                });
                riscaldamentoCondizionamento.content[index].hidden = true;
            }
            var dispositiviAntincendio = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.dispositiviAntincendio";
            });
            if (dispositiviAntincendio
                && dispositiviAntincendio.content
                && Array.isArray(dispositiviAntincendio.content)) {
                var index = dispositiviAntincendio.content.findIndex(function (item) {
                    return item.key === "evac";
                });
                dispositiviAntincendio.content[index].hidden = true;
            }
        }
        else {
            var strutture = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.strutture";
            });
            if (strutture
                && strutture.content
                && Array.isArray(strutture.content)) {
                var index = strutture.content.findIndex(function (item) {
                    return item.key === "condominiBsc";
                });
                strutture.content[index].hidden = true;
                index = strutture.content.findIndex(function (item) {
                    return item.key === "fabbricatoAbitativo";
                });
                strutture.content[index].hidden = false;
                index = strutture.content.findIndex(function (item) {
                    return item.key === "struttureFabbindip";
                });
                strutture.content[index].hidden = false;
            }
            var trattamentoAcqua = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.trattamentoAcqua";
            });
            if (trattamentoAcqua
                && trattamentoAcqua.content
                && Array.isArray(trattamentoAcqua.content)) {
                var index = trattamentoAcqua.content.findIndex(function (item) {
                    return item.key === "sottostazioneAltroCondBsc";
                });
                trattamentoAcqua.content[index].hidden = false;
            }
            var riscaldamentoCondizionamento = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.riscaldamentoCondizionamento";
            });
            if (riscaldamentoCondizionamento
                && riscaldamentoCondizionamento.content
                && Array.isArray(riscaldamentoCondizionamento.content)) {
                // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                //   return item.key === "sottostazioniCt"
                // });
                // riscaldamentoCondizionamento.content[index].hidden = false;
                // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                //   return item.key === "centraleRicervimento"
                // });
                // riscaldamentoCondizionamento.content[index].hidden = false;
                var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                    return item.key === "cannaCollettiva";
                });
                riscaldamentoCondizionamento.content[index].hidden = false;
            }
            var dispositiviAntincendio = this.mappingIndex.find(function (el) {
                return el.title === "properties.structures.dispositiviAntincendio";
            });
            if (dispositiviAntincendio
                && dispositiviAntincendio.content
                && Array.isArray(dispositiviAntincendio.content)) {
                var index = dispositiviAntincendio.content.findIndex(function (item) {
                    return item.key === "evac";
                });
                dispositiviAntincendio.content[index].hidden = false;
            }
        }
    };
    /**
     * Check if given macr-section item is visibile or not depending on
     * structure open status. If structure is open, than this will always returns true
     * If it's false, this will check if at least one sub-section has one or more
     * values. If so, return true, otherwise return false;
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.checkVisibility = function (item) {
        var _this = this;
        var condoStructureClose = true;
        if (condoStructureClose) {
            if (item.content && item.content.length) {
                // Let's make anagrafica section ALWAYS visible
                if (item.content[0].key === "anagrafica") {
                    return true;
                }
                return item.content.some(function (subitem) { return _this.getChildren(subitem.key).length; });
            }
            return false;
        }
        return true;
    };
    /**
     * Get children (existing values) for requested section
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.getChildren = function (key) {
        if (typeof this.condoStructure !== "undefined"
            && typeof this.condoStructure[key] !== "undefined") {
            if (key === "anagrafica") {
                return [];
            }
            else {
                if (Array.isArray(this.condoStructure[key])) {
                    var structures = JSON.parse(JSON.stringify(this.condoStructure[key]));
                    structures = structures.filter(function (el) { return el.active; });
                    return structures;
                }
                else {
                    return [];
                }
            }
        }
        return [];
    };
    /**
     * Navigate to given section inside the same property detail page
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.activateSection = function (rawSection) {
        this.dialog.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // Reset data and call the new data form
        this.formActiveSubitemId = undefined;
        var controls = this.form.controls;
        for (var key in controls) {
            this.form.removeControl(key);
        }
        var section = rawSection.replace(":structureId", this.property.structure);
        this.formActiveSubitemId = "";
        this.formActiveSection = section;
        this.updateFormSection();
    };
    /**
     * Handle form item click and open view/edit popup
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.onFormItemClick = function (rawSection, item) {
        this.dialog.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        var section = rawSection.replace(":structureId", this.property.structure);
        this.formActiveSubitemId = item._id;
        this.formActiveSection = section;
        this.updateFormSection();
    };
    /**
     * Update form section depending on route params
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.updateFormSection = function () {
        var _this = this;
        // Reset model to prevent import previous form data
        if (this.model) {
            for (var property in this.model) {
                delete this.model[property];
            }
        }
        this.dialog.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // Reset data and call the new data form
        if (this.form) {
            this.options.formState = {
                disabled: true
            };
        }
        // Add section param to routing, which is used in connections type
        var params = Object.assign({}, this.activatedRoute.snapshot.params, { selected: false });
        params.mappingFormActiveSection = this.formActiveSection;
        this.activatedRoute.snapshot.params = params;
        if (this.formActiveSection) {
            this.formIsLoading = true; // Start form loading
            // BEGIN - Set open status to current mapping index
            var origFormActiveSection_1 = this.formActiveSection.replace(this.property.structure, ":structureId");
            this.mappingIndex.map(function (item) {
                item.content.map(function (subItem) {
                    if (subItem.section === origFormActiveSection_1) {
                        // Get currente element is a Plant
                        // delete note field from form
                        if (subItem.formConfig
                            && Array.isArray(subItem.formConfig)
                            && subItem.formConfig.length) {
                            if (subItem.formConfig[0].fieldGroup
                                && Array.isArray(subItem.formConfig[0].fieldGroup)
                                && subItem.formConfig[0].fieldGroup.length) {
                                var index = subItem.formConfig[0].fieldGroup.findIndex(function (el) {
                                    return el.key === "note";
                                });
                                if (index > -1) {
                                    subItem.formConfig[0].fieldGroup.splice(index, 1);
                                }
                            }
                        }
                        if (item.title === "properties.structures.impiantiElettrici" ||
                            item.title === "properties.structures.trattamentoAcqua" ||
                            item.title ===
                                "properties.structures.riscaldamentoCondizionamento" ||
                            item.title === "properties.structures.dispositiviAntincendio" ||
                            item.title === "properties.structures.ascensoriEMontauto" ||
                            item.title === "properties.structures.impiantiElettronici" ||
                            item.title === "properties.structures.lineeVita" ||
                            item.title === "properties.structures.impiantiSpeciali" ||
                            item.title === "properties.structures.impiantiRicreativi") {
                            _this.sectionPlant = true;
                        }
                        else {
                            _this.sectionPlant = false;
                        }
                        item.expanded = true;
                        subItem.active = true;
                        _this.activeItem = subItem;
                        if (_this.formActiveSection &&
                            origFormActiveSection_1 !==
                                "condo-structures/:structureId/anagrafica") {
                            var children = _this.getChildren(subItem.key);
                            if (children.length) {
                                _this.activeSubitem = children.find(function (val) { return val._id === _this.formActiveSubitemId; });
                                if (_this.activeSubitem && _this.activeSubitem.files) {
                                    if (_this.form.controls.files) {
                                        _this.form.controls.files.setValue(_this.activeSubitem.files);
                                    }
                                    _this.form.updateValueAndValidity();
                                }
                                _this.fields = subItem.formConfig;
                                if (_this.activeSubitem) {
                                    _this.model = _this.activeSubitem;
                                }
                                else {
                                    // Add new subitem. Default name from section
                                    var tot = children.length + 1;
                                    var nome = _this.translateService.instant(subItem.title) + " " + tot;
                                    _this.model = { nome: nome };
                                }
                            }
                            else {
                                // New first subitem. Default name from section
                                _this.fields = subItem.formConfig;
                                var nome = _this.translateService.instant(subItem.title) + " 1";
                                _this.model = { nome: nome };
                            }
                        }
                        else if (subItem.section === "condo-structures/:structureId/anagrafica") {
                            _this.activeSubitem = _this.condoStructure.anagrafica;
                            // Anagrafica: is not completed
                            if (typeof _this.activeSubitem === "undefined") {
                                _this.activeSubitem = {
                                    active: true
                                };
                            }
                            _this.fields = subItem.formConfig;
                            _this.model = _this.activeSubitem;
                            _this.formActiveSubitemId = Math.random().toString();
                        }
                    }
                    else {
                        subItem.active = false;
                    }
                });
            });
            if (this.form && !this.condoStructure.open) {
                this.options.formState = {
                    disabled: true
                };
            }
            // END - Set open status to current mapping index
            setTimeout(function () {
                _this.formIsLoading = false;
            }, 300);
        }
        else {
            // Reset the last item.expanded mappingIndex to close tree from previous structure
            if (Array.isArray(this.mappingIndex) && this.mappingIndex.length) {
                this.mappingIndex.forEach(function (item) {
                    if (item.expanded) {
                        item.expanded = false;
                        if (Array.isArray(item.content) && item.content.length) {
                            item.content.forEach(function (elem) {
                                if (elem.active) {
                                    elem.active = false;
                                }
                            });
                        }
                    }
                });
            }
        }
    };
    /**
     * Translate all keys with given labels inside given object and returns it
     *
     * @since 1.0.0
     */
    ViewStructureDialogComponent.prototype.translateKeys = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                for (var prop in item) {
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            item[prop] = _this.translateService.instant(item[prop]);
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys(keys, item[prop]);
                        }
                    }
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    ViewStructureDialogComponent.prototype.translateKeys2 = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                var _loop_1 = function (prop) {
                    if (prop === "hooks") {
                        var propKey_1 = item[prop];
                        item[prop] = {
                            onInit: function (field) {
                                field.defaultValue = propKey_1 + " " + (+field.parent.key + 1);
                            },
                        };
                    }
                    if (prop === "hideExpression" && item[prop]) {
                        var propKey_2 = item[prop].key;
                        var propCompareValue_1 = item[prop].value;
                        if (item[prop].operator === "!==") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return currentValue !== compareValue;
                            };
                        }
                        else if (item[prop].operator === "!") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                return !currentValue;
                            };
                        }
                        else if (item[prop].operator === "!includes") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return typeof currentValue === "undefined" || !currentValue.includes(compareValue);
                            };
                        }
                    }
                    if (prop === "expressionProperties" && item[prop]) {
                        var propDisabled = item[prop].disabled;
                        if (typeof item[prop].required !== "undefined") {
                            var propKey_3 = item[prop].required.key;
                            var propCompareValue_2 = item[prop].required.value;
                            if (item[prop].required.operator === "===") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        var compareValue = propCompareValue_2;
                                        return currentValue === compareValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "!") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return !currentValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return currentValue;
                                    }
                                };
                            }
                        }
                        else {
                            item[prop] = {
                                "templateOptions.disabled": propDisabled,
                            };
                        }
                    }
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            if (item["translation"]) {
                                item[prop] = item["translation"].it;
                            }
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys2(keys, item[prop]);
                        }
                    }
                };
                for (var prop in item) {
                    _loop_1(prop);
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (prop === "options" && Array.isArray(obj[prop])) {
                        obj[prop].forEach(function (elem) {
                            if (elem.value && elem.value === "true") {
                                elem.value = true;
                            }
                            else if (elem.value && elem.value === "false") {
                                elem.value = false;
                            }
                        });
                    }
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                        if (prop === "label" && obj["translationLabel"]) {
                            obj[prop] = obj["translationLabel"].it;
                        }
                        else if (prop === "placeholder" && obj["translationPlaceholder"]) {
                            obj[prop] = obj["translationPlaceholder"].it;
                        }
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys2(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     */
    ViewStructureDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    /**
     * Handle panel header open/close
     *
     * @since 1.0.0
     *
     */
    ViewStructureDialogComponent.prototype.onPanelClicked = function (item, index) {
        item.expanded = !item.expanded;
        this.mappingIndex.forEach(function (el, i) {
            if (i !== index) {
                el.expanded = false;
            }
        });
        // Handle scroll to panel
        if (item.expanded) {
            var headerHeight = 60;
            var top_1 = (headerHeight * (index + 1)) - headerHeight;
            this.dialog.scrollTo({
                top: top_1,
                behavior: "smooth"
            });
        }
    };
    return ViewStructureDialogComponent;
}());
export { ViewStructureDialogComponent };
